import * as styles from "./TextEditorToolbar.css";

import { clsx } from "clsx";
import { Fragment, type JSX } from "react";

import { Separator } from "@frontend/components/atoms/Separator";
import { useLingui } from "@lingui/react/macro";

import type { TextEditorToolbarProps } from "./TextEditor.types";
import { TextEditorLinkTool } from "./TextEditorLinkTool";
import { TextEditorToolbarButton } from "./TextEditorToolbarButton";
import { TEXT_EDITOR_TOOLS, TEXT_EDITOR_TOOL_GROUPS } from "./constants";

export function TextEditorToolbar({
  label,
  tools = TEXT_EDITOR_TOOLS,
  variant,
  placement,
  className,
}: TextEditorToolbarProps): JSX.Element {
  const { t } = useLingui();

  return (
    <div
      data-slot="text-editor-toolbar"
      role={tools.length > 0 ? "toolbar" : undefined}
      aria-label={tools.length > 0 ? t`Formatting` : undefined}
      className={clsx(styles.toolbar({ variant, placement }), className)}
    >
      {label === undefined ? null : (
        <span data-slot="text-editor-label" className={styles.label}>
          {label}
        </span>
      )}

      {tools.map((tool, index) => {
        const previous = tools[index - 1];

        const startsGroup =
          previous !== undefined &&
          TEXT_EDITOR_TOOL_GROUPS[previous] !== TEXT_EDITOR_TOOL_GROUPS[tool];

        return (
          <Fragment key={tool}>
            {startsGroup ? (
              <Separator orientation="vertical" className={styles.separator} />
            ) : null}

            {tool === "link" ? (
              <TextEditorLinkTool />
            ) : (
              <TextEditorToolbarButton tool={tool} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
